module.exports = __webpack_public_path__ + "img/title-1.eca470a6.png";